import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { computed, onMounted, ref } from 'vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { useRouter } from 'vue-router';
import { getActivityInformations } from '@/api/common';
import { useUserStore } from '@/stores/user';
import { getFirstRechargeRewardEligible } from '@/api/deposit';
import NewFirstRechargeOne from '@/themes/themeOne/firstDeposit/newFirstRecharge.vue';
import NewFirstRechargeTwo from '@/themes/themeTwo/firstDeposit/newFirstRecharge.vue';
import NewFirstRechargeThree from '@/themes/themeThree/firstDeposit/newFirstRecharge.vue';
import { FirstDepositData } from './newFirstRecharge';
import { useThemeStore } from '@/stores/theme';
import CarteiraView from '../carteiraView/carteiraView.vue';

interface ConfigData {
    activeStatus: number;
    day: number;
    recharge_config: any[];
}
interface FirstRechargeData {
    activityIntro: any;
    config: {
        config: [];
        isRewardEligible: boolean
    }
}

export default /*@__PURE__*/_defineComponent({
  __name: 'newFirstRecharge',
  setup(__props) {

const userStore = useUserStore()
const themeStore = useThemeStore()
const router = useRouter();
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const walletPopupRef = ref()

const firstRechargeData = ref<FirstRechargeData>({
    activityIntro: '',
    config: {
        config: [],
        isRewardEligible: false
    }
})

const activityInfo = ref([])
const configList = ref<ConfigData[]>([])
const selectedTabData = ref<any>({})
const isRewardEligible = ref(false)
const bannerIcon = ref('')
const rechargeBonusStatus = ref(0)

const dataSet = computed<FirstDepositData>(() => ({
    activityInfo: activityInfo.value,
    configList: configList.value,
    selectedTabData: selectedTabData.value,
    isRewardEligible: isRewardEligible.value,
    bannerIcon: bannerIcon.value  ,
    rechargeBonusStatus: rechargeBonusStatus.value 
}))

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const goToDeposit = () => {
    userStore.setRechargeBonusType(3)
    if (selectedTabData.value?.activeStatus === 1 && isRewardEligible.value) {
        checkFirstRechargeEligible()
    }
}
const getActivityInfo = () => {
    loadingRef.value.open()
    let data = {
        activityId: "daily_first_recharge",
    }
    getActivityInformations(data).then(res => {
        loadingRef.value.close()
        if (res.data) {
            bannerIcon.value = res.data?.floatIcon
            firstRechargeData.value = res.data
            activityInfo.value = JSON.parse(firstRechargeData.value?.activityIntro);
            configList.value = firstRechargeData.value?.config?.config
            isRewardEligible.value = firstRechargeData.value?.config?.isRewardEligible
            rechargeBonusStatus.value = res.data?.config?.rechargeBonusStatus
            
            let activeTab = configList.value.find((item: any) => item.isToday === true)
            if (activeTab) {
                selectedTabData.value = activeTab
            } else {
                let lengthArray = configList.value?.length
                selectedTabData.value = configList.value[lengthArray - 1]
            }
        }
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const selectTab = (item: any) => {
    selectedTabData.value = item
}

const checkFirstRechargeEligible = () => {
    loadingRef.value.open()
    getFirstRechargeRewardEligible().then(res => {
        loadingRef.value.close()
        if(themeStore.themeIndex === 1 || themeStore.themeIndex === 3){
         router.push({ path: '/sd-topup'});
         } else if (themeStore.themeIndex === 2){
            walletPopupRef?.value?.openPopup(0)
         }
        userStore.setisFirstRechargeRewardEligible(res.data)
        userStore.setTakeFirstDeposit(res.data)
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close()
            showError(err)
        }
    });
}
onMounted(() => {
    getActivityInfo()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(NewFirstRechargeOne, {
            "data-set": dataSet.value,
            onGoToDeposit: goToDeposit,
            onSelectTab: selectTab
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(NewFirstRechargeTwo, {
            "data-set": dataSet.value,
            onGoToDeposit: goToDeposit,
            onSelectTab: selectTab
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(NewFirstRechargeThree, {
            "data-set": dataSet.value,
            onGoToDeposit: goToDeposit,
            onSelectTab: selectTab
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    _createVNode(CarteiraView, {
      ref_key: "walletPopupRef",
      ref: walletPopupRef
    }, null, 512)
  ], 64))
}
}

})